<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="View Log Book">
      <v-btn
        @click="$router.push({ name: 'logBookLists' })"
        v-if="$vuetify.breakpoint.smAndUp"
        elevation="1"
        absolute
        right
        top
      >
        <v-icon left>mdi-arrow-left</v-icon>back
      </v-btn>
      <v-btn
        v-else
        fixed
        right
        fab
        small
        color="grey lighten-2"
        elevation="1"
        class="mr-n2 mt-10"
        style="opacity:.6;"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-card-component>
        <v-row>
          <v-col cols="6" md="3">
              <v-icon color="primary">mdi-account</v-icon>
              <span class="label-color">Name:</span>
              <label
                class="uppercase">
              {{this.logData.teacherName[0].user.firstName+this.logData.teacherName[0].user.lastName}}
            </label>
          </v-col>
          <v-col cols="6" md="3">
            <span class="desc">
              <v-icon color="primary">mdi-calendar</v-icon>
              <span class="label-color">Date:</span>
              {{ logData.logDate }}
            </span>
          </v-col>
        </v-row>

        <v-row>
        <v-data-table
          :headers="headers"
          :items="logBookTopicMapsData"
          :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
          :items-per-page="10"
        >
          <template v-slot:item.content="{ item }">{{ item.content ? item.content : '-' }}</template>
          <template
            v-slot:item.resourcesRequired="{ item }"
          >{{ item.resourcesRequired ? item.resourcesRequired : '-' }}</template>
          <template
            v-slot:item.teacherTask="{ item }"
          >{{ item.teacherTask ? item.teacherTask : '-' }}</template>
          <template v-slot:item.parentTask="{ item }">{{ item.parentTask ? item.parentTask : '-' }}</template>
          <template
            v-slot:item.outcomeofTheClass="{ item }"
          >{{ item.outcomeofTheClass ? item.outcomeofTheClass : '-' }}</template>
          <template
            v-slot:item.outcomeToBeObserved="{ item }"
          >{{ item.outcomeToBeObserved ? item.outcomeToBeObserved : '-' }}</template>
          <template
            v-slot:item.furtherStepsPlanned="{ item }"
          >{{ item.furtherStepsPlanned ? item.furtherStepsPlanned : '-' }}</template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>

        </v-row>
      <!-- end -->
      <v-row>
        <v-col cols="12">
          <h3 style="font-size:18px; font-weight: 500; color:#000;">Remark Lists</h3>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headerRemark"
        :items="logBookTopicRemarks"
        :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
        :items-per-page="10"
      >
        <template
          v-slot:item.remarkByName="{ item }"
        >{{ item.remarkByName ? item.remarkByName : '-' }}</template>
        <template v-slot:item.remark="{ item }">{{ item.remark ? item.remark : '-' }}</template>
        <template
          v-slot:item.remarkDate="{ item }"
        >{{ new Date(item.remarkDate).toLocaleDateString() || '-' }}</template>

        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>
      </v-data-table>
      <!-- <v-row v-for="(item,index) of logBookTopicRemarks" :key = index>
        <v-col cols="12" sm="12" md="8">
          <h3 style="font-size:16px; font-weight: 500">{{item.remarkByName}}</h3>
          <h4 style="font-size:14px; font-weight: 400">{{item.remark}}</h4>
         </v-col>
        <v-col cols="12" sm="12" md="4">
           <h4 style="font-size:14; font-weight: 400;text-align:right; ">{{item.remarkDate}}</h4>
        </v-col>
      </v-row>-->
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
// import { mapGetters } from 'vuex'
import Utils from '@/utils'
import moment from 'moment'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['logBookID'],
  name: 'viewLogBookEntry',
  async created () {
    await this.getLogDetails()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
  },
  computed: {},
  watch: {},
  data () {
    return {
      isWrite: true,
      logDate: '',
      logData: [],
      content: '',
      logBookTopicMapsData: [],
      logBookTopicRemarks: [],
      remark: '',
      remarkByName: '',
      remarkDate: '',
      headers: [
        { text: 'Topic Name', sortable: true, value: 'topicName[0].name' },
        { text: 'Content', sortable: true, value: 'content' },
        { text: 'Resources', sortable: true, value: 'resourcesRequired' },
        { text: 'Teacher Task', sortable: true, value: 'teacherTask' },
        { text: 'Parent Task', sortable: true, value: 'parentTask' },
        { text: 'Expected Outcomes', sortable: true, value: 'outcomeofTheClass' },
        { text: 'Observed Outcomes', sortable: true, value: 'outcomeToBeObserved' },
        { text: 'Future Plans', sortable: true, value: 'furtherStepsPlanned' }
      ],
      headerRemark: [
        { text: 'Remark By', sortable: true, value: 'remarkByName' },
        { text: 'Remark', sortable: true, value: 'remark' },
        { text: 'Remark Date', sortable: true, value: 'remarkDate' }
      ]
    }
  },
  methods: {
    getLogDetails: async function () {
      try {
        // if (this.academicYear.id) {
        let rows = await http.get(`${constants.API_URL}/api/log-book/get/${this.logBookID}`)
        this.logData = rows.data
        this.logData.logDate = moment(this.logData.Date).format('DD-MM-YYYY')

        this.logBookTopicMapsData = this.logData.logBookTopicMaps.map(items => {
          return items
        })
        this.logBookTopicRemarks = this.logData.logBookRemarks.map(r => {
          r.remarkByName = `${r.remarkByName.firstName} ${r.remarkByName.lastName}`
          // r.remarkDate = this.remarkDate
          return r
        })
      } catch (e) {
        console.log(e)
        return this.$dialog.error({
          text: (e && e.response && e.response.data.message) || e.message,
          title: 'Error'
        })
      }
    }
  }
}
</script>
<style scoped>
.desc {
  font-size: 18px;
}
.label-color {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
}
.uppercase {
}
</style>
